import CustomerNotification from '@/models/customer-notification'
import ProcessedCustomerNotification from '@/models/processed-customer-notification'

export default class BaseNotification {
  notification: CustomerNotification

  constructor(notification: CustomerNotification) {
    this.notification = notification
  }

  call(): ProcessedCustomerNotification {
    return {
      id: this.notification.id,
      enquiryId: this.notification.enquiryId,
      message: this.processedMessage,
      iconClass: this.iconClass,
    }
  }

  get processedMessage(): string {
    return this.notification.message.trim()
  }

  get iconClass(): string {
    return 'sc-icon-document'
  }
}
